import { Card, CardHeader, CardTitle, CardBody } from "../ui/Card.jsx";

/**
 * Card wrapper for a labeled section of a form. Used to break long forms
 * into digestible groupings (Basics / Specs / Gallery / SEO).
 */
export function FormSection({ title, description, children, footer }) {
  return (
    <Card>
      <CardHeader>
        <div>
          <CardTitle>{title}</CardTitle>
          {description && <p className="mt-0.5 text-xs text-text-secondary">{description}</p>}
        </div>
      </CardHeader>
      <CardBody className="space-y-5">{children}</CardBody>
      {footer}
    </Card>
  );
}
